<ion-content class="scroll-content img bg-image login-content" [ngStyle]="{'--background': getBackground()}">
  <ion-grid class="login-grid">
    <ion-row class="login-row">
      <ion-col size="12">
        <div class="logo-row">
          <ion-img class="logo" alt="logo" src="assets/logo.png" />
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="login-row">
      <ion-col>
        <form [formGroup]="login" (ngSubmit)="doLogin(login.value)">
          <ion-grid class="card-login">
            <ion-row *ngIf="isAnonimo && !isMessianica" class="ion-justify-content-start">
              <ion-col size="5">
                <ion-back-button class="back-button" (click)="closeModal()" text="{{'Voltar' | translate}}"
                  defaultHref=""></ion-back-button>
              </ion-col>
            </ion-row>

            <ion-row *ngIf="isMessianica" class="ion-justify-content-start">
              <ion-col size="6">
                <ion-back-button class="back-button" (click)="onboarding()" text="{{'Onboarding' | translate}}"
                  defaultHref=""></ion-back-button>
              </ion-col>
            </ion-row>

            <ion-row class="ion-align-items-center">
              <ion-col>
                <h3 class="welcome">{{'Bem-vindo' | translate}}</h3>
              </ion-col>
            </ion-row>

            <ion-row class="ion-justify-content-center">
              <ion-col size="10">
                <ion-input class="custom" [counter]="true"
                  placeholder="{{ isMessianica ? ('CPF' | translate) : ('Usuário' | translate) }}"
                  formControlName="usuario" [clearInput]="true" (ionChange)="user()">
                </ion-input>
              </ion-col>
            </ion-row>

            <ion-row class="ion-justify-content-center">
              <ion-col size="10">
                <ion-input fill="outline" class="custom height" [counter]="true" placeholder="{{'Senha' | translate}}"
                  [clearInput]="false" type="text" formControlName="password"
                  [ngStyle]="{'-webkit-text-security': senhaEscondida ? 'disc' : 'none'}">
                  <ion-button fill="clear" slot="end" aria-label="Show/hide" (click)="togglePasswordText()">
                    <ion-icon class="input-icon" slot="icon-only" name="{{senhaEscondida ? 'eye-off-outline' : 'eye-outline' }}"
                      aria-hidden="true"></ion-icon>
                  </ion-button>
                </ion-input>
              </ion-col>
            </ion-row>

            <ion-row class="ion-text-center">
              <ion-col size="12" class="forGot logo-row" (click)="goToForgotPassword()">
                <ion-label> {{'Esqueceu a senha?' | translate}} </ion-label>
              </ion-col>

              <ion-col size="12" class="logo-row ion-no-padding">
                <div class="erro" [class.show]="error">
                  <span>* {{'Usuário ou Senha Inválida' | translate}}</span>
                </div>
              </ion-col>
            </ion-row>

            <ion-row class="ion-align-items-center">
              <ion-col class="margin-min">
                <ion-button expand="block" type="submit" class="login-button"> {{'Entrar' | translate}} </ion-button>
              </ion-col>
            </ion-row>

            <ion-row *ngIf="!esconderCadastro">
              <ion-col class="cadastro" (click)="goToSignup(null)">
                <ion-label class="text-cadastro">{{'Ainda não tem conta?' | translate}}</ion-label>
                <ion-label> {{'Cadastrar' | translate}} </ion-label>
              </ion-col>
            </ion-row>

            <!-- <ion-row class="ion-align-items-center ion-justify-content-center"
              *ngIf="!esconderCadastro && !esconderFacebook">
              <ion-col size="4">
                <div class="linha"></div>
              </ion-col>

              <ion-col size="2" class="ion-text-center">
                <span class="ou-texto">{{'Ou' | translate}}</span>
              </ion-col>

              <ion-col size="4">
                <div class="linha"></div>
              </ion-col>
            </ion-row>

            <ion-row *ngIf="!esconderCadastro && !esconderFacebook"
              class="ion-align-items-center ion-justify-content-center ion-text-center ion-margin-bottom"
              style="color: #fff">
              <ion-col size="2">
                <i class="fa-brands fa-apple"></i>
              </ion-col>

              <ion-col size="2">
                <i class="fa-brands fa-facebook-f" (click)="loginFacebook()"></i>
              </ion-col>

              <ion-col size="2">
                <i class="fa-brands fa-google"></i>
              </ion-col>
            </ion-row> -->
          </ion-grid>
        </form>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>